import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React from "react";
import PropTypes from 'prop-types';
import { useState, useEffect, useCallback, useContext } from 'react';
import styled from 'styled-components';
import { Icon } from '@mch-group/uikit-components';
import ConfirmProvider, { ConfirmContext } from '@dmi-mch/contexts';
import { loadClodinaryWidgetScript, CloudinaryService } from '@dmi-mch/utils';
import Text from './Text';

var CloudinaryVideoUploader = function CloudinaryVideoUploader(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      disabled = _useState6[0],
      setDisabled = _useState6[1];

  var _useContext = useContext(ConfirmContext),
      showConfirm = _useContext.showConfirm,
      setVisible = _useContext.setVisible;

  useEffect(function () {
    setValue(props.value);
  }, [props]);
  useEffect(function () {
    loadClodinaryWidgetScript(function () {
      setLoaded(true);
    });
  }, []);

  var uploadWidget = function uploadWidget() {
    setDisabled(true);
    var openFileUploadWidget = CloudinaryService({
      cloudName: props.cloudName,
      uploadPreset: props.uploadPreset,
      sources: ['local'],
      resourceType: 'video',
      clientAllowedFormats: ['mp4', 'webp', 'AVI', 'MPEG2', 'MPEG4'],
      multiple: false
    }, function (error, result) {
      if (!error && result.event === 'success') {
        setValue(result.info.secure_url);
        props.onLoadComplete(result.info);
      }

      setDisabled(false);
    });
    openFileUploadWidget.open();
  };

  var deleteVideo = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            showConfirm({
              labels: {
                title: 'Delete Video',
                message: 'Are you sure you want to delete this video?',
                ok: 'Yes',
                cancel: 'No'
              },
              actions: {
                onOK: function onOK() {
                  props.onDeleteVideo(value);
                  setVisible(false);
                },
                onCancel: function onCancel() {
                  setVisible(false);
                }
              }
            });

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [props, setVisible, showConfirm, value]);
  var thumbnailUrl = value && value.replace(/\.[^/.]+$/, '.jpg');
  return loaded ? /*#__PURE__*/React.createElement("div", null, value ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledThumbnailImage, null, /*#__PURE__*/React.createElement("img", {
    src: thumbnailUrl,
    className: "video-thumbnail-img",
    alt: "video-thumbnail-img"
  }), /*#__PURE__*/React.createElement("div", {
    className: "delete",
    onClick: deleteVideo,
    onKeyUp: deleteVideo,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "delete"
  })))) : /*#__PURE__*/React.createElement(StyledVideoUploadContainer, {
    onClick: !disabled ? uploadWidget : function () {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center justify-content-center add-btn"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "add"
  }), /*#__PURE__*/React.createElement(Text, {
    isHtml: true,
    isSmall: true,
    textColor: "#bdbdbd",
    lineHeight: "17px",
    className: "d-block"
  }, props.placeholderMessage)))) : null;
};

var StyledThumbnailImage = styled.div.withConfig({
  displayName: "CloudinaryVideoUploader__StyledThumbnailImage",
  componentId: "sc-nudeea-0"
})(["&:hover{.video-thumbnail-img{opacity:0.5;}.delete{display:block !important;cursor:pointer;}}.delete{display:none;}.delete{position:absolute;text-align:center;top:120px;width:320px;}img{position:relative;width:320px;height:210px;}"]);
var StyledVideoUploadContainer = styled.div.withConfig({
  displayName: "CloudinaryVideoUploader__StyledVideoUploadContainer",
  componentId: "sc-nudeea-1"
})(["width:320px;height:210px;border:1px solid lightgrey;border-style:dashed;cursor:pointer;.add-btn{padding:8px;height:210px;}"]);
CloudinaryVideoUploader.propTypes = {
  cloudName: PropTypes.string,
  uploadPreset: PropTypes.string,
  onLoadComplete: PropTypes.func,
  onDeleteVideo: PropTypes.func,
  headingText: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  value: PropTypes.string,
  placeholderMessage: PropTypes.string
};

var hoc = function hoc(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React.createElement(ConfirmProvider, null, " ", /*#__PURE__*/React.createElement(WrappedComponent, props), " ");
  };
};

export default hoc(CloudinaryVideoUploader);